var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gContainer page",attrs:{"id":"Dashboard"}},[_vm._v(" No reports available at this time ")])}
var staticRenderFns = []

export { render, staticRenderFns }